import React from "react";
import { formatDocument, formatFullName } from "../gestionCarteraFormat";
import { ModalShell, SecondaryButton } from "../gestionCarteraUi";
import CreditInvoicePanel from "./CreditInvoicePanel";

/** Factura del comercio de cada crédito del cliente: ver la de cada uno y cargar la de uno APPROVED o COMPLETED. */
export default function FacturaClienteModal({ open, client, onClose }) {
  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title="Factura"
      subtitle={client ? `${formatFullName(client)} · ${formatDocument(client)}` : ""}
      maxWidth="md"
      actions={<SecondaryButton onClick={onClose}>Cerrar</SecondaryButton>}
    >
      {open && client?.uuid && <CreditInvoicePanel clientUuid={client.uuid} />}
    </ModalShell>
  );
}
